import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
    collapse,
    expand,
    setContentToState
} from 'Feature/ContentComponents/code/assets/componets/accordion/js/accordion.component';
import ComponentsFactory from 'foundation/components-factory';
import app from '../../../general/js/app';
import QualifiedGolfersPlayersList from './QualifiedGolfersPlayersList';
import { interpolateWithPlural } from '../../../general/js/string-helpers';

class PreviousQualificationEvent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isGolfersShown: false
        };
        this.rootRef = React.createRef();
        this.restPlayersRef = this.restPlayersRef.bind(this);
        this.onVisibilityTriggerClick = this.onVisibilityTriggerClick.bind(this);
    }

    componentDidMount() {
        ComponentsFactory.getInstance().init(this.rootRef.current);
    }

    componentWillUnmount() {
        ComponentsFactory.getInstance().destroy(this.rootRef.current);
    }

    onVisibilityTriggerClick() {
        const isGolfersShown = !this.state.isGolfersShown;
        this.handleRestPlayersVisibility(isGolfersShown);
        this.setState({ isGolfersShown });
    }

    handleRestPlayersVisibility(isVisible) {
        if (isVisible) {
            expand(this.restPlayersElement);
        } else {
            collapse(this.restPlayersElement);
        }
    }

    restPlayersRef(el) {
        this.restPlayersElement = el;
        setContentToState(this.restPlayersElement, this.state.isGolfersShown);
    }

    getPlayersToShow() {
        if (app.isDesktopWide) {
            return 5;
        } if (app.isDesktop) {
            return 4;
        }
        return 3;
    }

    getPreviewPlayers() {
        return this.props.event.golfers.slice(0, this.getPlayersToShow());
    }

    getRestPlayers() {
        return this.props.event.golfers.slice(this.getPlayersToShow());
    }

    render() {
        const previewPlayers = this.getPreviewPlayers();
        const restPlayers = this.getRestPlayers();

        const event = this.props.event;

        return (
            <div className="previous-qualification-event" ref={this.rootRef}>
                <div className="previous-qualification-event__logo">
                    {event.logoImageSrcSet ?
                        <img data-srcset={event.logoImageSrcSet} data-sizes="auto"
                            className="lazyload" alt=""/> :
                        null}
                </div>
                <div className="previous-qualification-event__content">
                    <div className="previous-qualification-event__title">
                        {event.title}
                    </div>
                    <div className="previous-qualification-event__players-qualified">
                        <div className="previous-qualification-event__players-qualified-count">
                            {this.getPlayersQualifiedCaption()}
                        </div>
                        {
                            event.infoLink &&
                            <a className="previous-qualification-event__info-btn"
                                data-dc-component="modal-trigger"
                                href={event.infoLink}
                                aria-label={`Read more about ${event.title}`}
                            >
                                <svg className="icon previous-qualification-event__info-btn-icon"
                                    width="16"
                                    height="16">
                                    <use xlinkHref="#icon-btn-info"></use>
                                </svg>
                            </a>
                        }

                    </div>
                    <div className="previous-qualification-event__players">
                        <QualifiedGolfersPlayersList items={previewPlayers}/>
                    </div>
                    {restPlayers.length > 0 ? (
                        <div>
                            <div ref={this.restPlayersRef}
                                className="previous-qualification-event__players">
                                <QualifiedGolfersPlayersList items={restPlayers}/>
                            </div>
                            <button onClick={this.onVisibilityTriggerClick}
                                className="previous-qualification-event__show-more-players-button button-tertiary button-tertiary--icon">
                                <span className="button-content">
                                    {this.getTriggerButtonCaption(restPlayers.length)}
                                    <svg width="10" height="6"
                                        className={`icon previous-qualification-event__show-more-players-button-icon ${this.state.isGolfersShown ? 'is-opened' : ''}`}>
                                        <use xlinkHref="#icon-arrow-down"></use>
                                    </svg>
                                </span>
                            </button>
                        </div>
                    ) : null}
                </div>
            </div>
        );
    }

    getTriggerButtonCaption(restPlayersCount) {
        if (this.state.isGolfersShown) {
            return 'Hide';
        }
        const { single, plural } = this.props.translations.showPlayers;
        return interpolateWithPlural(single, plural, restPlayersCount);
    }

    getPlayersQualifiedCaption() {
        const { single, plural } = this.props.translations.qualifiedPlayers;
        return interpolateWithPlural(single, plural, this.props.event.golfers.length);
    }
}

PreviousQualificationEvent.propTypes = {
    translations: PropTypes.object.isRequired,
    event: PropTypes.object.isRequired,
    deviceType: PropTypes.string.isRequired
};

const mapStateToProps = (state) => {
    const { deviceType, translations } = state;
    return { deviceType, translations };
};

export default connect(mapStateToProps)(PreviousQualificationEvent);
